import React, { Component, Fragment } from 'react';

class FormElementEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { initialValues: { ...this.props.element } };
  }

  updateElement(formData) {
    this.props.onUpdate({
      ...this.props.element,
      ...formData,
    });
  }

  render() {
    return (
      <Fragment>
        <this.props.formComponent
          initialValues={this.state.initialValues}
          isLoading={this.props.isLoading}
          onClose={() => this.props.onClose()}
          onSave={formData => this.updateElement(formData)}
        />
      </Fragment>
    );
  }
}

export default FormElementEdit;
